import { selectedIsAuthorized } from '@shared-core/features/auth'
import { selectedCurrentUser } from '@shared-core/features/backend'
import { selectedUserPhone } from '@shared-core/features/settings'
import { useEvent } from '@shared-core/hooks/use-event'
import { PhoneEntryMode, ScreensList, useGoFromSheet, useNavigation } from '@shared-core/navigation'
import { useAppSelector } from '@shared-core/store'

// Единый гейт защищённых действий; публичные описания и справка открываются напрямую.
export function useAuthorizationGate({
  fromSheet = false,
  requireEmail = false,
}: {
  fromSheet?: boolean
  requireEmail?: boolean
} = {}) {
  const isAuthorized = useAppSelector(selectedIsAuthorized)
  const currentUser = useAppSelector(selectedCurrentUser)
  const userPhone = useAppSelector(selectedUserPhone)
  const navigation = useNavigation()
  const goFromSheet = useGoFromSheet()
  const hasPhone = isAuthorized && Boolean(currentUser?.phone?.number ?? userPhone)
  const hasEmail = isAuthorized && Boolean(currentUser?.email?.address)
  const ensureAuthorized = useEvent((isPhoneRequired = false) => {
    if (isAuthorized && (!isPhoneRequired || hasPhone)) {
      if (!requireEmail || hasEmail) return true

      if (fromSheet) goFromSheet(ScreensList.FORM_SHEET_EMAIL_PROMPT)
      else navigation.navigate(ScreensList.FORM_SHEET_EMAIL_PROMPT)
      return false
    }

    if (fromSheet) goFromSheet(ScreensList.ENTRY_PHONE, { mode: PhoneEntryMode.BIND })
    else navigation.navigate(ScreensList.ENTRY_PHONE, { mode: PhoneEntryMode.BIND })
    return false
  })
  return { isAuthorized, hasPhone, hasEmail, ensureAuthorized }
}
